import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Set a fixed countdown time for the demo (e.g., 2 hours, 15 mins, 30 secs)
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 15,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-4 my-6" data-id="element-33">
      <div className="flex flex-col items-center" data-id="element-34">
        <div className="bg-slate-900 border border-purple-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-white shadow-[0_0_15px_rgba(168,85,247,0.2)]" data-id="element-35">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-medium uppercase tracking-wider" data-id="element-36">
          Horas
        </span>
      </div>
      <div className="text-2xl font-bold text-purple-500 pb-6" data-id="element-37">:</div>
      <div className="flex flex-col items-center" data-id="element-38">
        <div className="bg-slate-900 border border-purple-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-white shadow-[0_0_15px_rgba(168,85,247,0.2)]" data-id="element-39">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-medium uppercase tracking-wider" data-id="element-40">
          Minutos
        </span>
      </div>
      <div className="text-2xl font-bold text-purple-500 pb-6" data-id="element-41">:</div>
      <div className="flex flex-col items-center" data-id="element-42">
        <div className="bg-slate-900 border border-purple-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-white shadow-[0_0_15px_rgba(168,85,247,0.2)]" data-id="element-43">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-medium uppercase tracking-wider" data-id="element-44">
          Segundos
        </span>
      </div>
    </div>;
}